import { render, staticRenderFns } from "./RealityAutobuyerBox.vue?vue&type=template&id=e9dfe834&scoped=true&"
import script from "./RealityAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./RealityAutobuyerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dfe834",
  null
  
)

export default component.exports